import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import autoBind from "react-autobind";
import { Row, Col } from "react-bootstrap";
import { ddadosHistorico as DDados } from "../historico.ddados";
import DDadosItem from "@common/components/ddados/ddados.item";
import historicoActions from "../store/historico.actions";
import historicoSelector from "../store/historico.selectors";
import { connect } from "@common/components/base.component";
import Button from "@material-ui/core/Button";
import moment from "moment";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async adicionar(item) {
    const historico = {
      DataRegistro: new Date(),
      Origem: 0,
      Historico: item.Historico,
      Usuario: "Solicitante"
    };

    await this.props.historicoActions.addSagaHistorico(historico);
    this.props.onClose();
  }

  render() {
    const { Campos } = DDados;
    const { onClose, prefix, form, show, parameters } = this.props;
    const { historico } = this.props.historicoSelector;
    const isView = prefix == "V";

    return (
      <Modal
        className={"mt-5 mb-5"}
        show={show}
        onHide={onClose}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Histórico</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <DDadosItem
                name="Historico"
                {...Campos.Historico}
                state={parameters}
                isView={isView}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" color="primary" onClick={onClose}>
            <i className={`mr-1 fa ${isView ? "fa-times" : "fa-ban"}`} />{" "}
            {`${isView ? "Fechar" : "Cancelar"}`}
          </Button>
          {!isView && (
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                this.adicionar({ Historico: form.values.Historico })
              }
            >
              Adicionar
              <i className={"fas fa-plus ml-2"} />
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect({
  actions: {
    historicoActions
  },
  selectors: {
    historicoSelector
  }
})(Container);
